import { Skill } from "./Skill";

/**
 * A set of skills
 * @class
 * @property {Object} skills A map of skills by category
 */

export class SkillSet {
    skills: Skill[] = [];
    constructor(skills: Skill[] = []) {
        skills.forEach((skill: any) => {
            if (skill instanceof Skill) this.addSkill(skill);
            else {
                this.addSkill(new Skill(skill.category, skill.skill, skill.level));
            }

        });
    }

    /**
     * Add a skill to the skill set
     * @param {Skill} skill The skill to add
     * @returns {SkillSet} The skill set
     * @example
     * var skill = new Skill("Frontend", "HTML", 3);
     * var skillset = new SkillSet();
     * skillset.addSkill(skill);
     */
    addSkill(skill: Skill): SkillSet {
        this.skills.push(skill);
        return this;
    }

    /**
     * Get all skills in the skill set
     * @returns {Array} An array of skills
     */
    toString(): string {
        return this.skills.map(skill => `${skill.category}: ${skill.skill} (${skill.level})`).join(" | ");
    }

    /**
     * Get all skills in the skill set
     * @returns {Array} An array of skills
     */
    all(): Skill[] {
        return this.skills;
    }
}
